import { Button, ButtonIcon } from '@components/ui/Button'
import styles from './styles.module.scss'
import { ReactComponent as FilterIcon } from '@svgs/filter.svg'
import CollectionContext from '@components/collection/collectionContext'
import { useContext } from 'react'
import { FilterOption } from 'types/filters'
import {
  ChildFilterValue,
  FilterBuild,
  FilterBuildItem,
  FilterBuildItemValue,
  ParentFilterValue
} from '../types'
import useIsReactClient from '@helpers/hooks/useIsReactClient'

function isParentFilterValue(
  item: FilterBuildItemValue
): item is ParentFilterValue {
  return 'values' in item && Array.isArray(item.values)
}

function doesItemMatchFilters(
  item: FilterBuildItemValue,
  filterOptions: FilterOption[]
): boolean {
  return filterOptions.some(
    filter =>
      item.title?.toLowerCase() === filter.type.toLowerCase() &&
      isParentFilterValue(item) &&
      item.values.some(
        value => (value as ChildFilterValue).value === filter.value
      )
  )
}

function countSelectedChildWithFilter(
  filterBuild: FilterBuild,
  filterOptions: FilterOption[]
) {
  let count = 0

  function traverseValues(values: FilterBuildItem['values'] | undefined): void {
    if (!Array.isArray(values)) return

    for (const item of values) {
      if (doesItemMatchFilters(item, filterOptions)) {
        count++
      }

      if (isParentFilterValue(item)) {
        traverseValues(item.values)
      }
    }
  }

  filterBuild.forEach(item => traverseValues(item.values))

  return count
}

function FilterToggleButton({
  totalResults,
  filterBuild,
  filterOptions
}: {
  totalResults: number
  filterBuild: FilterBuild
  filterOptions: FilterOption[]
}) {
  const { openFilters } = useContext(CollectionContext)
  const isReactClient = useIsReactClient()
  const total = countSelectedChildWithFilter(filterBuild, filterOptions)
  const filterOptionsTotalValue = total > 0 ? ` (${total})` : ''

  return (
    <div className={styles.filterContainer}>
      <div className={styles.filterContainer__wrapper}>
        <Button
          classes={styles.filtersButton}
          variant="white_outline"
          size="small"
          fullWidth="never"
          onClick={openFilters}
        >
          <ButtonIcon>
            <FilterIcon
              aria-label="filter icon"
              width="18"
              height="18"
              fill="white"
            />
          </ButtonIcon>
          <span>Filter my size{filterOptionsTotalValue}</span>
        </Button>
        {isReactClient && (
          <p className={styles.filtersResults}>
            {totalResults} styles available
          </p>
        )}
      </div>
    </div>
  )
}

export default FilterToggleButton
